// extracted by mini-css-extract-plugin
module.exports = {"container":"Favourites_container__3t9Gp","scale":"Favourites_scale__X1Qs3"};